module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hvh1j"))).then(() => parcelRequire('hEqeo'));